import { Button, Loader, Modal, Paragraph, Title } from "@sicredi/react";
import { AppAlertTracking } from "#/components/TrackingComponents/AppAlertTracking";
import { ConsorcioContratadoTracking } from "#/components/TrackingComponents/ConsorcioContratadoTracking";
import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { AssembleiaTracking } from "#/components/TrackingComponents/AssembleiaTracking";
import { Line } from "#/components/Line";
import {
  getVendasListaPropostaByIdDocumento,
  handleEmitirRegulamento,
  toastErrorMenssage,
} from "#/contextProver/ContextProverServices";
import { ContextAPI } from "#/contextProver/ContextProver";
import styles from "./styles.module.scss";
import { SimulacaoTracking } from "#/components/TrackingComponents/SimulacaoTracking";
import { PagamentoTracking } from "#/components/TrackingComponents/PagamentoTracking";
import { AssinaturaContratoTracking } from "#/components/TrackingComponents/AssinaturaContratoTracking";
import { PAGE } from "#/constants";
import { getVendasBoleto, IGetVendasBoletoData } from "#/api/getVendasBoleto";
import { IGetVendasContratoData } from "#/api/getVendasContrato";
import { getVendasListaProposta } from "#/api/getVendasListaProposta";
import { ButtonLinkChevronRight } from "#/components/ButtonLinkChevronRight";
import { cancelarProposta } from "#/api/cancelarProposta";

export const TrackingScreen: React.FC = () => {
  const {
    idProduto,
    codigoComissionado,
    vendasListaProposta,
    idDocumento,
    setVendaBoleto,
    setVendasContrato,
    documento,
    setVendasListaProposta,
    setIsMenuConsorcio,
    isMenuConsorcio,
    isLoading,
    setIsLoading,
  } = useContext(ContextAPI);
  const navigate = useNavigate();

  const [isOpenModalCancelar, setIsOpenModalCancelar] = useState(false);

  const tracking = getVendasListaPropostaByIdDocumento({
    vendasListaProposta,
    idDocumento,
  });

  const paragraphSize = (state: boolean | undefined | null) =>
    state !== false ? "small" : "medium";

  const isBoletoPago = tracking?.boletoPago === "S";
  const isBoletoGerado = tracking?.boletoGerado === "S";
  const isAssinadoContrato = tracking?.contratoAssinado === "S";
  const isContratoGerado = tracking?.contratoGerado === "S";
  const isAssinaturaVencida = tracking?.assinaturaVencida === "S";
  const assembleiaDate = tracking?.dataPrimeiraAssembleia;

  const goback = async () => {
    setVendaBoleto({} as IGetVendasBoletoData);
    setVendasContrato({} as IGetVendasContratoData);
    setIsLoading(true);
    try {
      const vendasListaProposta = await getVendasListaProposta({
        codigoComissionado,
        documento,
      });
      setVendasListaProposta(vendasListaProposta);
      setIsLoading(false);
      if (isMenuConsorcio) {
        setIsMenuConsorcio(false);
        navigate(PAGE.ROOT);
      } else {
        navigate(PAGE.ROOT);
      }
    } catch {
      setIsLoading(false);
      toastErrorMenssage();
    }
  };

  const handleGoBoletoAdesao = async () => {
    try {
      setIsLoading(true);
      const vendaBoleto = await getVendasBoleto({
        idDocumento,
        codigoComissionado,
        documento,
      });
      setVendaBoleto(vendaBoleto);

      const vendasListaProposta = await getVendasListaProposta({
        codigoComissionado,
        documento,
      });
      setVendasListaProposta(vendasListaProposta);

      setIsLoading(false);
      navigate(PAGE.BOLETO_ADESAO);
    } catch {
      setIsLoading(false);
      toastErrorMenssage();
    }
  };

  const handleCancelarProposta = async () => {
    setIsLoading(true);
    try {
      await cancelarProposta({
        codigoComissionado,
        documento,
        idDocumento,
      });

      const vendasListaProposta = await getVendasListaProposta({
        codigoComissionado,
        documento,
      });
      setVendasListaProposta(vendasListaProposta);

      setIsLoading(false);
      setIsOpenModalCancelar(false);
      navigate(PAGE.ROOT);
    } catch {
      setIsLoading(false);
      setIsOpenModalCancelar(false);
    }
  };

  useEffect(() => {
    if (!vendasListaProposta || !idDocumento) {
      navigate(PAGE.ROOT);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {tracking && (
        <>
          <div className={styles.container}>
            <Loader show={isLoading} fullScreen />
            <Title as="h1" className={styles.title_h1}>
              Situação da contratação
            </Title>

            {isBoletoPago && <AppAlertTracking />}

            <SimulacaoTracking
              state={true}
              paragraphSize={paragraphSize}
              onClick={async () =>
                await handleEmitirRegulamento({
                  idProduto,
                  codigoComissionado,
                  setIsLoading,
                })
              }
            />

            <AssinaturaContratoTracking
              isIconWarning={isContratoGerado && !isAssinadoContrato}
              paragraphSize={paragraphSize}
              vencimentoBoleto={tracking.dataVencimetoBoletoAdesao}
              isContratoGerado={isContratoGerado}
              isAssinaturaVencida={isAssinaturaVencida}
              state={isAssinadoContrato}
            />

            <PagamentoTracking
              state={isBoletoPago}
              isIconWarning={isBoletoGerado}
              isBoletoGerado={isBoletoGerado}
              isContratoAssinado={isAssinadoContrato}
              paragraphSize={paragraphSize}
              onClick={handleGoBoletoAdesao}
              vencimentoBoleto={tracking.dataVencimetoBoletoAdesao}
            />

            <ConsorcioContratadoTracking
              state={isBoletoPago}
              isIconClock={!isBoletoPago}
              paragraphSize={paragraphSize}
              grupo={tracking.cdGrupo}
              cota={tracking.cdCota}
            />

            <AssembleiaTracking
              state={
                assembleiaDate !== "0001-01-01 00:00:00" &&
                tracking?.situacaoGrupo === "Andamento"
              }
              assembleiaDate={assembleiaDate}
              isBoletoPago={isBoletoPago}
              paragraphSize={paragraphSize}
            />

            <div>
              <Button
                className={styles.button_back}
                onClick={goback}
                appearance="primary"
                block={true}
              >
                Voltar
              </Button>
              {!isBoletoPago && (
                <div className={styles.button_cancelar}>
                  <ButtonLinkChevronRight
                    text="Cancelar proposta"
                    onClick={() => setIsOpenModalCancelar(true)}
                    marginTop={0}
                  />
                </div>
              )}
            </div>
          </div>

          <div className={styles.container_paragraph_small}>
            <Line />
            <div className={styles.paragraph_small}>
              <Paragraph size="small" weight="normal">
                As simulações pendentes serão canceladas automaticamente após a
                data de vencimento do boleto de adesão.
              </Paragraph>
            </div>
          </div>
        </>
      )}
      <Modal
        title="Deseja cancelar a proposta?"
        onClose={() => setIsOpenModalCancelar(false)}
        show={isOpenModalCancelar}
        secondaryButton={{
          children: "Sim",
          onClick: async () => await handleCancelarProposta(),
        }}
        primaryButton={{
          children: "Não",
          onClick: () => setIsOpenModalCancelar(false),
        }}
      >
        Tem certeza que deseja cancelar sua proposta?
      </Modal>
    </>
  );
};
